<template>
  <div class="row" style="padding-top: 20px">
    <div class="col-sm-10 col-sm-offset-1" style="background:white;border-radius:10px" v-if="user">
      <img :src="user.photoUrl" height="300px" style="border-radius:10px;margin-top:10px"/>
      <h3>{{user.firstName}} {{user.lastName}}</h3>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4"
        style="margin-bottom:20px"
        v-for="item in items"
        :key="item.label">
          <label>{{item.label}}</label>
          <p class="itemValue">{{item.value}}</p>
        </div>
      </div>

      <button v-if="!user.superfan" @click="superfan" class="btn btn-success">Grant SuperFan</button>

      <br><br>

      <button @click="timeout" class="btn btn-warning">Timeout</button>

      <br><br>

      <button @click="underage" class="btn btn-primary">Under Age</button>

      <br><br>

      <button @click="suspend" class="btn btn-danger">Suspend</button>

    <br><br>
    <hr>

    <h4>Reported</h4>
    <p v-for="(post, idx) in user.reported" :key="`reported_${idx}`">{{post.reason}}</p>

    <h4>Messages</h4>
    <p v-for="(post, idx) in user.messages" :key="`message_${idx}`">{{post.message}}</p>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { StoreActions } from "./store/actions";
import StoreIndex from "./store/_StoreIndex";
import {StoreState as state} from './store/state'
// import { StoreMutations } from './store/mutations';
export default {
  name: "User",
  components: {
  },
  data() {
    return {
      showReportedPosts: false,
      showReportedComments: false,
      showReported: false,
      showPosts: false,
      showComments: false,
      showDeletedPosts: false,
      filter: "",
      deletedFilter: ""
    };
  },
  mounted() {
      this.getUser()
  },
  destroyed() {
    this.dispatch(StoreActions.clearState);
  },
  methods: {
    commit(path, value) {
      this.$store.commit(`${StoreIndex.path}/${path}`, value);
    },
    dispatch(path, value) {
      this.$store.dispatch(`${StoreIndex.path}/${path}`, value);
    },
    getUser() {
      let userId = this.$route.params.id
      this.dispatch(StoreActions.getUser,userId);
    },
    timeout() {
      let userId = this.$route.params.id
      this.dispatch(StoreActions.timeout,userId);
    },
    underage() {
      let userId = this.$route.params.id
      this.dispatch(StoreActions.underage,userId);
    },
    suspend() {
      let userId = this.$route.params.id
      this.dispatch(StoreActions.restrict,userId);
    },
    superfan() {
      let userId = this.$route.params.id
      this.dispatch(StoreActions.superfan,userId);
    }
  },
  computed: {
    ...mapState(StoreIndex.path,[
      state.user,
      state.messages
    ]),
    items() {
      if(!this.user) {
        return []
      }
      return [
        {
          label:'First Name',
          value:`${this.user.firstName}`
        },
        {
          label:'Last Name',
          value:`${this.user.lastName}`
        },
        {
          label:'Username',
          value:`@${this.user.username}`
        },
        {
          label:'Apple ID',
          value:this.user.appleId
        },
        {
          label:'SuperFan',
          value:this.user.superfan ? 'Yes' : 'No'
        },
        {
          label:'Email',
          value:this.user.email
        },
        {
          label:'Bio',
          value:this.user.bio
        },
        {
          label:'Birthday',
          value:this.user.birthday
        },
        {
          label:'Lat',
          value:this.user.lat
        },
        {
          label:'Lng',
          value:this.user.lng
        },
        {
          label:'Restricted',
          value:this.user.restricted
        },
        {
          label:'loginIp',
          value:this.user.loginIP
        },
        {
          label:'uuid',
          value:this.user.uuid
        },
        {
          label:'timeout',
          value:this.user.timeout
        },
        {
          label:'Under Age',
          value:this.user.underage
        },
        {
          label:'Date Created',
          value:this.user.created
        },


        {
          label:'Pronouns',
          value:this.user.pronouns
        },
        {
          label:'Me Answer Count',
          value:this.user.meAnsweredCorrect
        },
        {
          label:'Award Answer Count',
          value:this.user.awardAnswerCount
        },
        {
          label:'Nearby Recently-Active Only',
          value:this.user.nearbyRecentlyActiveOnly ? 'Yes' : 'No'
        },
        {
          label:'Referred by',
          value:this.user.referredByUserId
        },
        {
          label:'Group Chat Privacy',
          value:this.user.groupChatPrivacy
        },
        {
          label:'Device Language',
          value:this.user.deviceLanguage
        },
        {
          label:'Hide Steps',
          value:this.user.hideSteps ? 'Yes' : 'No'
        },
        {
          label:'Collect Steps',
          value:this.user.collectSteps ? 'Yes' : 'No'
        }
      ]
    }
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

label {
  color:gray;
}

.itemValue {
  color:black;
  font-size: medium;
}
</style>
